import { Policy } from '@carbon/icons-react';
import { defineSection } from '@/app/registry';

/**
 * Политики биржи (БО-22, HR-40…42, Приложение D «политики биржи»): порог открытия заявок (HR-12), сроки и SLA
 * модерации, монетизация (три механизма под флагами до решения собственника), «защита штата» (черновик →
 * утверждение собственником dodoc). Чтение — DODOC_MODERATOR, изменения — DODOC_ADMIN.
 */
export const section = defineSection({
  id: 'backoffice.exchange-policies',
  area: 'backoffice',
  path: 'exchange-policies/*',
  roles: ['DODOC_MODERATOR', 'DODOC_ADMIN'],
  icon: Policy,
  titleKey: 'exchangePolicies:title',
  namespaces: ['backoffice', 'moderation'],
  navGroup: 'library',
  order: 400,
  load: () => import('./PoliciesPage'),
});
